import React , {useState} from 'react';
import {
  Box,
  IconButton,
  Typography,
  Tooltip,
  Button
} from '@mui/material';
import { ArrowBack, Clear , CheckBox, CheckBoxOutlineBlank } from '@mui/icons-material';
import { PopoverListButtons } from '../../../Utils/styledComps';
import { original } from '@reduxjs/toolkit';
const CustomCombinePopoverContent = ({
  selectedFeature,
  combine,
  handleBackButtonClick,
  handlePopoverClose,
  originalVisibility,
  handleChangeView
}) => {
  const renderPopoverContent = () => {
    if (selectedFeature) {
      const feature = combine.find(item => item.label === selectedFeature);
      return (
        <Box sx={{ height: 500, width: 300 }}>
          <Box sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            px: 1.25,
            py: 1
          }}>
            <Tooltip title="Back" arrow>
              <IconButton
                edge="start"
                onClick={handleBackButtonClick}
                aria-label="Go back"
                sx={{ borderRadius: 1 }}
              >
                <ArrowBack />
              </IconButton>
            </Tooltip>
            <Typography variant="h6" sx={{ color: 'action.hover', fontWeight: 800 }}>
              {selectedFeature}
            </Typography>
            <Tooltip title="Close menu" arrow>
              <IconButton
                edge="end"
                onClick={handlePopoverClose}
                aria-label="Close combine menu"
                sx={{ borderRadius: 1 }}
              >
                <Clear />
              </IconButton>
            </Tooltip>
          </Box>
          <Box sx={{ display: 'flex', gap: 1, m: 1.25, flexWrap: 'wrap' }}>
            {feature?.children?.map((obj, index) => (
              <Tooltip key={index} title={obj.label} arrow placement="bottom">
                <PopoverListButtons
                  onClick={obj.onClick}
                  aria-label={obj.label}
                >
                  {obj.icon}
                </PopoverListButtons>
              </Tooltip>
            ))}
          </Box>
        </Box>
      );
    }

    return (
      <Box sx={{ height: 500, width: 300 }}>
        <Box sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          px: 1.25,
          py: 1
        }}>
          <Typography variant="h6" sx={{ color: 'action.hover', fontWeight: 800 }}>
            Combine Options
          </Typography>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Tooltip title={originalVisibility ? "Hide original" : "Show original"} arrow>
              <IconButton
                onClick={handleChangeView}
                aria-label={originalVisibility ? "Hide original visibility" : "Show original visibility"}
                sx={{ borderRadius: 1, color: 'action.hover' }}
              >
                {originalVisibility ? <CheckBox /> : <CheckBoxOutlineBlank />}
              </IconButton>
            </Tooltip>
            <Tooltip title="Close menu" arrow>
              <IconButton
                edge="end"
                onClick={handlePopoverClose}
                aria-label="Close combine menu"
                sx={{ borderRadius: 1 }}
              >
                <Clear />
              </IconButton>
            </Tooltip>
          </Box>
        </Box>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, m: 1.25 }}>
          {combine.map((obj, index) => (
            <Button
              key={index}
              onClick={obj.onClick}
              variant='outlined'
              aria-label={obj.label}
              sx={{
                alignItems: 'center',
                justifyContent: 'space-between',
                display: 'flex',
                transition: (theme) => theme.transitions.create(['transform'], {
                  duration: theme.transitions.duration.shorter,
                }),
                '&:hover': {
                  transform: 'translateY(-2px)',
                },
              }}
            >
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                {obj.icon}
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                {obj.label}
              </Box>
            </Button>
          ))}
        </Box>
      </Box>
    );
  };

  return (
    <>
      {renderPopoverContent()}
    </>
  );
};

export default CustomCombinePopoverContent;
